<section id="intro-app-development" class="section-bg-dark">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 pl-5">
                <h2 class="text-white">QA-QUALITY ASSURANCE</h2>
            </div>
        </div>
    </div>
</section>

<section id="mantenience_services">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-xs-12">
                <p class="font-medium">
                    Nuestro equipo de profesionales proporciona al cliente el servicio de QA y el soporte necesario para
                    que tu aplicación,
                    tenga los mayores ratios de fiabilidad, acompañando al mismo en todos los procesos o servicios
                    establecidos según sus necesidades.
                </p>
            </div>
        </div>
    </div>
    <section>
        <div class="container">
            <div class="container">
                <div class="row p-2">
                    <div class="col-xs-12 w-100 text-center p-4">
                        <h2>QUALITY MANAGEMENT</h2>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <p class="font-medium">
                            El proyecto es testeable de principio a fin, con metodologías estandarizadas de pruebas
                            automatizadas y manuales.

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section>
        <div class="container">
            <div class="container">
                <div class="row p-2">
                    <div class="col-xs-12 w-100 text-center p-4">
                        <h2>PROCESO DEL QUALITY MANAGEMENT: QA</h2>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row">
                    <div class="col-sm-12 col-xs-12">
                        <p class="font-medium">
                            Somos especialistas en testing y control de calidad para prevenir errores en sistemas en
                            producción, evoluciones y nuevas funcionalidades, aplicando metodologías estandarizadas de pruebas.
                        </p>
                    </div>
                </div>
            </div>

            <div class="row justify-content-between">
                @for (section of sections; track section) {
                <div class="card col-sm-12 col-md-6 text-center p-2">
                    <div class="card-body">
                        <div class="border_box">
                            <h5>{{ section.title }}</h5>
                            <p>{{ section.description }}</p>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </section>

</section>